import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=2e8f0954&scoped=true&"
import script from "./DateFilter.vue?vue&type=script&lang=ts&"
export * from "./DateFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DateFilter.vue?vue&type=style&index=0&id=2e8f0954&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f0954",
  null
  
)

export default component.exports